import { useQuery } from '@tanstack/react-query';
import {
  TimesheetWeekHoursItemDto,
  TimesheetWeekHoursDto,
} from 'src/api/FiretrolApiClient';
import { timesheetApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type { TimesheetWeekHoursItemDto, TimesheetWeekHoursDto };

/** @registry Every timesheet a user has for one work week, with hours broken out per pay code. */
export function useTimesheetWeekHours(
  userId: number | undefined,
  year: number | undefined,
  weekId: number | undefined,
) {
  const enabled =
    Number.isFinite(userId) && Number.isFinite(year) && Number.isFinite(weekId);

  return useQuery({
    queryKey: queryKeys.timesheets.weekHours(userId!, year!, weekId!),
    queryFn: ({ signal }) =>
      timesheetApiClient.getTimesheetWeekHours(
        userId!,
        year!,
        weekId!,
        toCancelToken(signal),
      ),
    enabled,
    meta: {
      errorContext: 'timesheet week hours',
    },
  });
}
